import React from 'react';

import Row from 'react-bootstrap/lib/Row';
import { AMPWaveBack, AMPWaveMiddle, AMPWaveFront } from '../../AMPWave';
import OutboundLink from '../../OutboundLink';
import Icon from '../../../shared/Icon/index.tsx';
import PlatformBadge from './PlatformBadge';
import styles from '../styles.sass';
import AMPTrackedLink from '../../AMPTrackedLink';
import { EmbeddedYoutubeVideo } from '../../EmbeddedYoutubeVideo';
import { AppStoreButton, PlayStoreButton } from '../../AppDownloadButtons';
import {
  isIOS,
  isAndroidChrome,
} from '../../../../helpers/serverRenderingUtils';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const HeaderSection = () => (
  <div className={styles.homeHeader}>
    <Row bsClass={`${styles.aligned} ${styles.headerCopy} row`}>
      <h1>The best way to make your podcast.</h1>
      <div>
        <p>
          Create and host unlimited episodes, distribute your show everywhere,
          and make money. All in one place, all for free.
        </p>
        {!isIOS() &&
          (!isAndroidChrome() && (
            <div>
              <AMPTrackedLink
                eventCategory="Onboarding"
                eventLabel="Start"
                to="/signup"
              >
                <button className={`cyanButton ${styles.linkButton}`}>
                  Get started now
                </button>
              </AMPTrackedLink>
              <div className={styles.platformBadgeSectionContainer}>
                <div className={styles.platformBadgeSection}>
                  <OutboundLink
                    to="https://itunes.apple.com/app/apple-store/id1056182234?pt=118017867&ct=WebsiteTracking&mt=8"
                    newWindow
                    className={styles.platformBadgeLink}
                  >
                    <PlatformBadge
                      renderIcon={() => (
                        <div className={styles.appleLogoWrapper}>
                          <Icon type="apple_logo" fillColor="#ffffff" />
                        </div>
                      )}
                      label="App Store"
                      contentClass={styles.appleStoreBadgeContent}
                    />
                  </OutboundLink>
                  <OutboundLink
                    to="https://play.google.com/store/apps/details?id=fm.anchor.android&referrer=utm_source%3DAnchor%2520Home%26utm_medium%3Dcpc%26utm_campaign%3DAnchor%2520Home%26anid%3Dadmob"
                    newWindow
                    className={styles.platformBadgeLink}
                  >
                    <PlatformBadge
                      renderIcon={() => (
                        <Icon type="google_play_logo" fillColor="#ffffff" />
                      )}
                      label="Google Play"
                      contentClass={styles.googlePlayStoreBadgeContent}
                    />
                  </OutboundLink>
                </div>
              </div>
            </div>
          ))}
        {isIOS() && (
          <div className={styles.platformBadgeContainer}>
            <AppStoreButton width={181} />
          </div>
        )}
        {isAndroidChrome() && (
          <div className={styles.platformBadgeContainer}>
            <PlayStoreButton width={181} />
          </div>
        )}
      </div>
    </Row>
    {/* Positioned here to avoid using z-index on waves */}
    <AMPWaveBack />
    <AMPWaveMiddle />
    <div className={styles.videoWrapper}>
      <EmbeddedYoutubeVideo
        title="Anchor: The Easiest Way to Start a Podcast"
        youtubePlaylistId="PLJ_1GxcJR2S_7SbiQo3tdfVvJR6tLnS8d"
        paddingBottomOffset="56.25%"
        youtubeEmbedParameters={{
          autoplay: 1,
          controls: 1,
          modestbranding: 1,
          loop: 1,
          cc_load_policy: 1,
          mute: 1,
          rel: 0,
        }}
      />
    </div>
    <AMPWaveFront />
  </div>
);

export default HeaderSection;
